<script setup lang="ts">
import { useI18n } from 'vue-i18n'
import { useAgentsRealtime } from '@/composables/realtime/useAgentsRealtime.ts'

const { t } = useI18n()
const emit = defineEmits<{
  refresh: []
}>()
const isRealtimeActivated = ref(localStorage.getItem('va_realtime') === 'true')

watch(isRealtimeActivated, (val) => {
  localStorage.setItem('va_realtime', String(val))
})
const { refresh } = useAgentsRealtime()

const handleRefresh = () => {
  emit('refresh')
  refresh()
}
</script>
<template>
  <div class="flex items-center space-x-3">
    <OSwitch
      v-if="false"
      v-model="isRealtimeActivated"
      :label="t('activate_realtime')"
      leadingIcon="information"
      class="whitespace-nowrap"
    />

    <OButton size="M" :label="t('refresh')" @click="handleRefresh" dataTestid="refresh-button">
      <template #icon> <UiIcon name="refresh" variant="solid" /></template>
    </OButton>
  </div>
</template>
